import lodash from 'lodash'
import React, { useMemo } from 'react'
import { SetterOrUpdater, useRecoilState } from 'recoil'

import { receiverState } from './state'
import { TReturnAppReceiver } from './TReturnApp'

export type TReturnAppUpdate = {
  receiver: TReturnAppReceiver
  setReceiver: SetterOrUpdater<TReturnAppReceiver>
  logo: string
  title: string
  theme: object
  returnRoutePrefix: string
}

const useReturnApp = (): TReturnAppUpdate => {
  const [receiver, setReceiver] =
    useRecoilState<TReturnAppReceiver>(receiverState)

  const logo = useMemo(() => {
    const receiverLogo = receiver?.logo
    return receiverLogo && receiverLogo !== ''
      ? receiverLogo
      : global?.tenantSettings?.returnlogo
  }, [receiver])

  const title = useMemo(() => {
    if (receiver?.returntitle && receiver.returntitle != '') {
      return receiver.returntitle
    }
    return lodash.get(global, 'tenantSettings.returntitle', i18n.t('returns', 'Retouren'))
  }, [receiver])

  const theme = useMemo(() => {
    const { primaryColor, secondaryColor } = receiver || {}
    const backgroundColor =
      primaryColor && primaryColor !== ''
        ? primaryColor
        : lodash.get(global, 'tenantSettings.returncolor', '#afafaf')
    const fontColor =
      secondaryColor && secondaryColor !== ''
        ? secondaryColor
        : lodash.get(global, 'tenantSettings.defaultFontColor', 'white')
    return { backgroundColor, headerTextColor: fontColor, linkColor: fontColor }
  }, [receiver])

  return {
    receiver,
    setReceiver,
    logo,
    title,
    theme,
    returnRoutePrefix: lodash.get(global, 'returnRoutePrefix', ''),
  }
}

export default useReturnApp
